<template src='./bases.html'></template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'
import { genericFunction } from '@/commons.js'

export default {
  name: "Bases",
  data() {
    return {
      alertMsg: '',
      base_voice: '',
      bases: [],
      current_id: null,
      currentPage: 1,
      formData: {},
      id2Delete: null,
      paginatedBases: [],
      perPage: 10,
      selectedBase: {},
      showAlert: false,
      showModal: false,
      totalPages: 1,
      totalRows: 0,
      voices: [],
      voices_selected: [],
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        this.updatePaginatedBases()
      }
    },
    perPage: {
      handler(){
      
        this.currentPage = 1
        this.updatePaginatedBases()
      }
    },
  },   
  async mounted() {

    await this.loadBases()
    await this.loadVoices()
    this.updatePaginatedBases()
  },
  methods: {
    addTag() {

      if(this.base_code) {
        
        const selectedVoice = this.voices.find(
          (voice) => voice.id === parseInt(this.base_code)
        )
       
        if(selectedVoice && !this.voices_selected.some((v) => v.id === selectedVoice.id)) {
         
          this.voices_selected.push(selectedVoice)
          this.base_code = null
          this.$forceUpdate()
        }
      }
    },
    cancelBase() {

      this.current_id = null
      this.selectedBase = {}
      this.voices_selected = []
    },
    deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },
    editRow(base) {
      
      this.selectedBase = { ...base }

      if(base.voices_list){
      
        if(base.voices_list.length > 0 && typeof base.voices_list[0] === 'string') {
      
          let tempVoices = []
        
          for(let voiceName of base.voices_list) {
        
            let foundVoice = this.voices.find(v=>v.voice_name === voiceName)
        
            if(foundVoice){
        
              tempVoices.push(foundVoice)
            }
          }
          this.voices_selected = JSON.parse(JSON.stringify(tempVoices))
        } 
        else {
          
          this.voices_selected = JSON.parse(JSON.stringify(base.voices_list))
        }
      } 
      else {
        this.voices_selected = []
      }
      console.debug("selected base", this.selectedBase)
      this.current_id = base.id
    },
    formatTag(tag) {
     
      if(typeof tag === 'object' && tag !== null && tag.voice_name) {
      
        return tag.voice_name
      }
      
      return String(tag)   
    },
    formattedVoices(voices) {
    
      if (Array.isArray(voices)) {
    
        return voices.join(' ')
      }

      return ''
    },
    genericFunction,     
    handleCancel() {

console.debug("*** handleCancel()")
      this.current_id = null
      this.selectedBase = {}
    },
    async handleDelete() {

      try {

        const url = API_URL + "price_list/BasesDetail/"+this.id2Delete+"/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadBases()
      }
      catch(error) {

        if(error.response.status == 500) {
        
          this.alertMsg = "Attenzione! La base risulta essere utilizzato da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questa base"
          this.showAlert = true
        }
      }
    },
    async insertBase() {

      if(this.selectedBase.base_code) {

        this.selectedBase.voiceNames = this.voices_selected.map(voice => typeof voice === 'object' ? voice.voice_name : voice)
      }
        
      const url = API_URL + "price_list/BasesDetail/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      await axios.post(url, {base_code: this.selectedBase.base_code, voices_list: this.selectedBase.voiceNames}, {headers})
      await this.loadBases()
      await this.updatePaginatedBases()
      this.selectedBase = {}
    },
    async loadBases() {

      this.bases = await this.genericFunction('fetchBases')() || []
      this.bases = this.bases.map(base => {
      
        if(!Array.isArray(base.voices_list)) {
          
          base.voices_list = []
        }

        return base
      })
      this.selectedBase = {}
      this.updatePaginatedBases()
    },
    async loadVoices() {

      this.voices = await this.genericFunction('fetchVoices')() || []
      console.debug("*** loadVoices() voices", this.voices) /**/
    },
    async onPageChange(page) {

      this.currentPage = page
    },
    onVoiceState(state, tag) {
 
      return tag //typeof tag === 'object' ? tag.voice_name : tag
    },
    async updateBase() {

      const voiceNames = this.voices_selected.map(voice => typeof voice === 'object' ? voice.voice_name : voice)
      const url = API_URL + "price_list/BasesDetail/" + this.current_id + "/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      await axios.patch(url, { base_code: this.selectedBase.base_code, voices_list: voiceNames}, {headers})
      await this.loadBases()
      await this.updatePaginatedBases()
      this.selectedBase = {}
      this.current_id = null
      this.loadVoices()
      this.voices_selected = []
    },
    updatePaginatedBases() {

      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      this.paginatedBases = this.bases.slice(start, end)
      this.loadVoices()
      this.voices_selected = []
      this.$forceUpdate()
    },
  },
}

</script>

<style scoped>

::v-deep(.form-check-input) {
  transform: scale(2); /* Adjust the scale factor as needed */
}

.row-selection:hover {
  background-color: lightgray;
}

</style>